export interface DocumentTemplateProgramInterface {
  id?: string;
  documentTemplateId: number;
  programId?: number;
  name: string;
  tabName: string;
  description?: string;
  approvable: boolean;
  faxable: boolean;
  alerts: boolean;
  showDuringIntake: boolean;
  showDuringAssessment: boolean;
  showWhenActive: boolean;
  allowInPortal: boolean;
  blockCaseNotesWhenDue: boolean;
  showClientNameOnFooter: boolean;
  showClientExternalIdOnFooter: boolean;
  showReportDateOnFooter: boolean;
  alertDaysAfterFinalized: number;
  alertDaysBeforeDue: number;
  createdAt: string;
  updatedAt: string;
  shared: boolean; // Campo virtual del backend
  documentTemplate?: {
    id: number;
    name: string;
  };
  program?: {
    id: number;
    name: string;
    abbreviationName: string;
  };
}

export class DocumentTemplateProgram
  implements DocumentTemplateProgramInterface
{
  id: string;
  documentTemplateId: number;
  programId?: number;
  name: string;
  tabName: string;
  description?: string;
  approvable: boolean;
  faxable: boolean;
  alerts: boolean;
  showDuringIntake: boolean;
  showDuringAssessment: boolean;
  showWhenActive: boolean;
  allowInPortal: boolean;
  blockCaseNotesWhenDue: boolean;
  showClientNameOnFooter: boolean;
  showClientExternalIdOnFooter: boolean;
  showReportDateOnFooter: boolean;
  alertDaysAfterFinalized: number;
  alertDaysBeforeDue: number;
  createdAt: string;
  updatedAt: string;
  shared: boolean;
  documentTemplate?: {
    id: number;
    name: string;
  };
  program?: {
    id: number;
    name: string;
    abbreviationName: string;
  };

  constructor(data: any) {
    this.id = data.id || '';
    this.documentTemplateId = data.documentTemplateId || 0;
    this.programId = data.programId;
    this.name = data.name || '';
    this.tabName = data.tabName || '';
    this.description = data.description;
    this.approvable = data.approvable || false;
    this.faxable = data.faxable || false;
    this.alerts = data.alerts || false;
    this.showDuringIntake = data.showDuringIntake || false;
    this.showDuringAssessment = data.showDuringAssessment || false;
    this.showWhenActive = data.showWhenActive || false;
    this.allowInPortal = data.allowInPortal || false;
    this.blockCaseNotesWhenDue = data.blockCaseNotesWhenDue || false;
    this.showClientNameOnFooter = data.showClientNameOnFooter || false;
    this.showClientExternalIdOnFooter =
      data.showClientExternalIdOnFooter || false;
    this.showReportDateOnFooter = data.showReportDateOnFooter || false;
    this.alertDaysAfterFinalized = data.alertDaysAfterFinalized || 0;
    this.alertDaysBeforeDue = data.alertDaysBeforeDue || 0;

    this.createdAt = data.createdAt || '';
    this.updatedAt = data.updatedAt || '';
    this.shared = data.shared || false;
    this.documentTemplate = data.documentTemplate;
    this.program = data.program;
  }

  toJson(): DocumentTemplateProgramInterface {
    return {
      id: this.id,
      documentTemplateId: this.documentTemplateId,
      programId: this.programId,
      name: this.name,
      tabName: this.tabName,
      description: this.description,
      approvable: this.approvable,
      faxable: this.faxable,
      alerts: this.alerts,
      showDuringIntake: this.showDuringIntake,
      showDuringAssessment: this.showDuringAssessment,
      showWhenActive: this.showWhenActive,
      allowInPortal: this.allowInPortal,
      blockCaseNotesWhenDue: this.blockCaseNotesWhenDue,
      showClientNameOnFooter: this.showClientNameOnFooter,
      showClientExternalIdOnFooter: this.showClientExternalIdOnFooter,
      showReportDateOnFooter: this.showReportDateOnFooter,
      alertDaysAfterFinalized: this.alertDaysAfterFinalized,
      alertDaysBeforeDue: this.alertDaysBeforeDue,

      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
      shared: this.shared,
      documentTemplate: this.documentTemplate,
      program: this.program,
    };
  }
}
